import React, { Component } from 'react';

class About extends Component {
    render() {
        return (
            <div>
                <img
                    src="https://optinmonster.com/wp-content/uploads/2018/06/android-404-845x504.png"
                    alt="notFoud"
                    style={{display: "block", margin: "auto", width: "50%"}}
                />
            </div>
        );
    }
}

export default About;